// extracted by mini-css-extract-plugin
module.exports = {"bookWrapper":"_2sS_tEJpRCWOh8nSJOjCol _3Y7xEtrTgaC28IokfnEvTA"};